import {
  required, between, requiredIf, helpers,
} from 'vuelidate/lib/validators';

// eslint-disable-next-line max-len
const waiverLowerThanReducedByValidator = (value, vm) => parseFloat(vm.reducedBy) >= parseFloat(value);
const dateIsLaterThanStartDateValidator = (value, vm) => (!helpers.req(value) || (value !== '' && vm.startDate !== '' && value >= vm.startDate));

const accommodationSelections = [
  'the lease will not be terminated due to non-payment of rent (but the Tenant must remain committed to the terms of the lease)',
  'there will be no rental increases during the pandemic period',
  'certain expenses will be waived',
  'any reductions in statutory charges such as land tax, council rates will be passed on to the Tenant',
  'Other',
];

export default {
  name: 'rent-relief-reductions',
  data: () => ({
    startDate: '',
    reviewDate: '',
    deferralDate: '',
  }),
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
  },
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    reducedBy: {
      get() {
        return this.getItem.adjustments.reduction.amount;
      },
      set(value) {
        this.setItem({
          adjustments: { reduction: { amount: value }, waiver: value / 2 },
        });
      },
    },
    rentContinuesToBePaid() {
      return 100 - this.reducedBy;
    },
    waiver: {
      get() {
        return this.getItem.adjustments.waiver;
      },
      set(value) {
        this.setItem({ adjustments: { waiver: value } });
      },
    },
    deferral() {
      return this.reducedBy - this.waiver;
    },
    hasAccommodations: {
      get() {
        return this.getItem.adjustments.accommodations.hasAccommodations
          ? 'yes'
          : 'no';
      },
      set(value) {
        this.setItem({
          adjustments: {
            accommodations: {
              hasAccommodations: (value === 'yes'),
              accommodations: [],
              other: '',
            },
          },
        });
      },
    },
    accommodationSelections() {
      return accommodationSelections;
    },
    accommodationSelection: {
      get() {
        return this.getItem.adjustments.accommodations.accommodations;
      },
      set(value) {
        const accommodations = {
          adjustments: {
            accommodations: {
              accommodations: value,
            },
          },
        };

        if (!value.includes('Other')) {
          accommodations.adjustments.accommodations.other = '';
        }
        this.$store.dispatch('toolkit/updateItemKey', { data: accommodations });
      },
    },
    other: {
      get() {
        return this.getItem.adjustments.accommodations.other;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', {
          data: { adjustments: { accommodations: { other: value } } },
        });
      },
    },
  },
  watch: {
    startDate(value) {
      this.setItem({ adjustments: { reduction: { startDate: value } } });
    },
    reviewDate(value) {
      this.setItem({ adjustments: { reduction: { reviewDate: value } } });
    },
    deferral(value) {
      this.setItem({ adjustments: { deferral: value } });
    },
    deferralDate(value) {
      this.setItem({ adjustments: { deferralDate: value } });
    },
    '$v.$invalid': {
      immediate: true,
      handler: function isComponentValid(value) {
        this.$emit('valid', !value);
      },
    },
  },
  mounted() {
    this.startDate = this.getItem.adjustments.reduction.startDate !== null
      ? new Date(this.getItem.adjustments.reduction.startDate)
      : '';
    this.reviewDate = this.getItem.adjustments.reduction.reviewDate !== null
      ? new Date(this.getItem.adjustments.reduction.reviewDate)
      : '';
    this.deferralDate = this.getItem.adjustments.deferralDate !== null
      ? new Date(this.getItem.adjustments.deferralDate)
      : '';
  },
  validations: {
    reducedBy: {
      required,
      between: between(0, 100),
    },
    waiver: {
      required,
      waiverLowerThanReducedByValidator,
      between: between(0, 100),
    },
    startDate: {
      required,
    },
    reviewDate: {
      required,
      dateIsLaterThanStartDateValidator,
    },
    deferralDate: {
      dateIsLaterThanStartDateValidator,
    },
    hasAccommodations: {
      required,
    },
    accommodationSelection: {
      required: requiredIf(function hasAccommodationsRequired() {
        if (this.hasAccommodations === 'yes') {
          return true;
        }
        return false;
      }),
    },
    other: {
      required: requiredIf(function otherRequired() {
        if (
          this.accommodationSelection.findIndex(value => value === 'Other')
          >= 0
        ) {
          return true;
        }
        return false;
      }),
    },
  },
};
